import * as React from 'react';
import { multiStyles } from '../../utils';
import styles from '../styles.module.scss';

const Number = ({ className, value, setNum, editorMode, ...props }) => (
  <span className={multiStyles(styles, ['number', className])} {...props}>
    <div
      readOnly={!editorMode}
      value={value >= 0 && !isNaN(value) ? value : ''}
    >
      {value >= 0 && !isNaN(value) ? value : ''}
    </div>
  </span>
);

export default Number;
